import { GcpResourcePresets } from "./gcp.ts";

export const ResourcePresets = {
  ...GcpResourcePresets,
};
